import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { InvoiceBranding } from '../interfaces/sales/invoiceBranding.interface';

export const InvoiceBrandingService = {
  getByInstitution: async (institutionId: string): Promise<InvoiceBranding> =>
    (await axios.get(ENDPOINTS.INVOICE_BRANDING.BY_INSTITUTION(institutionId))).data,

  upsert: async (dto: InvoiceBranding): Promise<InvoiceBranding> =>
    (await axios.put(ENDPOINTS.INVOICE_BRANDING.UPSERT, dto)).data,

  uploadLogo: async (institutionId: string, file: File): Promise<InvoiceBranding> => {
    const formData = new FormData();
    formData.append('file', file);
    return (
      await axios.post(ENDPOINTS.INVOICE_BRANDING.LOGO(institutionId), formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
    ).data;
  },

  deleteLogo: async (institutionId: string): Promise<InvoiceBranding> =>
    (await axios.delete(ENDPOINTS.INVOICE_BRANDING.LOGO(institutionId))).data,

  getLogoBlob: async (institutionId: string): Promise<Blob> =>
    (await axios.get(ENDPOINTS.INVOICE_BRANDING.LOGO(institutionId), { responseType: 'blob' })).data,
};
